import itemQueries from '@apis/queries/itemQueries';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

function useItemNutrition(itemId: string) {
    const { data: nutrition, ...rest } = useQuery({
        ...itemQueries.nutrition(itemId),
        retry: 2,
    });
    const isNutritionExists = useMemo(() => {
        if (nutrition) {
            const keys = Object.keys(nutrition);
            for (let i = 0; i < keys.length; i += 1) {
                // @ts-ignore
                if (nutrition[keys[i]]) {
                    return true;
                }
            }
        }
        return false;
    }, [nutrition]);
    return { nutrition, isNutritionExists, ...rest };
}

export default useItemNutrition;
